import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ME } from "./actionTypes";
import axios from "axios";
import { AUTH_URL, USERS_URL, ME_URL } from "../../config";
import { routes } from "../constants/routes";
import { axiosRequestAuthHeader } from "../helpers/api";
import { history } from "../helpers/history";
import { clearAuthToken } from "../helpers/storage";
import { handleAuthentication } from "../helpers/authentication/authentication"
import { getAuthenticationType } from "../constants/AuthenticationType";

/**
 * Autoryzacja uzytkownika po stronie serwerowej.
 * 
 * Do żądania sieciowego wysyłamy dane authentyfikujące użytkownika (email i hasło), i w odpowiedzi dostajemy:
 * 
 *  - token JWT w przypadku pomyślej autentyfikacji
 * 
 *  - status 401 - brak autoryzacji
 * 
 * Wysyłamy parametr 'type' - typ wybranej autoryzacji. Jesli autoryzacja jest JWT to nie wysylamy bo jest to autoryzacja domyslana po stronie serwera
 *
 * @param {UserCredentials} userCredentials obiekt danych do uwierzytelnienia (email, passowrd)
 */
export const doLogin = (userCredentials) => {

  return dispatch => {
    return axios
      .post(`${AUTH_URL}`, JSON.stringify(userCredentials), {
        headers: {
          "Content-Type": "application/json"
        },
        params: {
          ...(getAuthenticationType().isDefault ? undefined : { type: getAuthenticationType().name })
        }
      })
      .then(response => {
        dispatch(createAuthUserSuccess(response.data));

        //no toast on success

        //obsługa otrzymanej odpowiedzi - w zależności od typu autoryzacji
        handleAuthentication(response.data, userCredentials);

        //dodajemy auth header do kazdego requestu - w zależności od typu autoryzacji
        axiosRequestAuthHeader();

        //przekierowujemy na home
        history.push(routes.HOME);
      })

  };
};

/**
 * Pobieranie danych zalogowanego użytkownika z serwera na podstawie tokena JWT
 * 
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const fetchMe = callback => {
  return dispatch => {
    return axios
      .get(USERS_URL + ME_URL)
      .then(response => {
        dispatch(fetchMeSuccess(response.data));
      })
      .then(() => callback && callback());
  };
};

/**
 * Akcja pomyślenej autentyfikacji użytkownika
 * 
 * @param {object} data obiekt tokena uzyskany przy autentyfikacji
 */
export const createAuthUserSuccess = data => {
  return {
    type: AUTH_LOGIN,
    payload: data
  };
};

/**
 * Akcja pomyślnego pobrania zalogowanego użytkownika
 * 
 * @param {object} data obiekt użytkownika uzyskany podczas pobrania danych zalogowanego użytkownika (na podstawie tokena)
 */
export const fetchMeSuccess = data => {
  return {
    type: AUTH_ME,
    payload: data
  };
};

/**
 * Akcja wylogowania użytkownika wraz z przekierowaniem na stronę startową aplikacji
 */
export const doLogout = () => {
  clearAuthToken();
  history.push(routes.LOGIN);
  return {
    type: AUTH_LOGOUT
  };
};

/**
 * Akcja przekierowania na stronę startową aplikacji
 */
export const doHome = () => {
  history.push(routes.HOME);
};
